const ButtonComponent = (props)=>{

    return (
        <button style={props.style} onClick={props.onClick} className={"font-roboto focus:outline-none focus:ring focus:ring-gray-300 "+props.className}>
            {props.children}
        </button>
    )

}

export default ButtonComponent